module.exports = __webpack_public_path__ + "img/crop-after.1cbcd1c4.webp";